import React from 'react'
import SubscriptionHeader from './SubscriptionHeader'
import PricingTable from './PricingTable'

const ProductDisplayWithHeader = ({ userId }) => {
  return (
    <div className="header-and-pricing">
      <SubscriptionHeader />
      <PricingTable userId={userId} />
    </div>
  )
}

export default ProductDisplayWithHeader
